import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedPlanAmount: cacheLs.get_plan_amount()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
